export { ApplePayButtonHeading } from './ApplePayButtonHeading'
